export default "__VITE_ASSET__D3fnw66w__";